import React, {useRef} from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {
  IComponentVolumes,
  IRecommendations,
  IState,
  Replacement,
  IServiceIntervals,
  ProductCategory,
} from '../../../../interface';
import OilRecommendationInformation from '../../OilRecommendationInformation';
import OilVolumesService from '../../OilVolumesService';
import Printable from '../../../RecommendationPrintable/Product';
import localesReplacement from '../../../../utils/localesReplacement';
import {connect} from 'react-redux';
import {useSearchParams} from 'react-router-dom';
import {Dispatch} from 'redux';
import actions from '../../../../redux/actions';
import _ from 'lodash';
import {useAppName} from '../../../../hooks/use-app-names';
import {APPNAME, FASTSCAN} from '../../../../constants';
import OilThumb from '../../OilThumb';

const cx = classnames.bind(style);

interface IProps {
  dataList: IRecommendations;
  replacements: Replacement;
  setVehicleComponentVolumes: (value: IComponentVolumes[]) => void;
  setServiceIntervals: (value: IServiceIntervals[]) => void;
  productCategories: ProductCategory[];
  vehicle?: any;
  notes?: string[];
}

export const CastrolRecommendation = (props: IProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    dataList,
    replacements,
    setVehicleComponentVolumes,
    setServiceIntervals,
    productCategories,
    vehicle,
    notes,
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const ref = useRef<HTMLDivElement>(null);
  const moreLinkClick = () => {
    setServiceIntervals(dataList.recommendedProduct.serviceIntervals ?? []);
    setVehicleComponentVolumes(dataList.vehicleComponentVolumes);
    searchParams.set('id', _.toString(dataList.recommendedProduct.id));
    searchParams.set('page', 'product');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };

  return (
    <>
      <Printable
        ref={ref}
        vehicle={vehicle}
        componentName={dataList.name}
        volumes={dataList.vehicleComponentVolumes}
        notes={notes}
        data={dataList.recommendedProduct}
      />
      <div className={cx('section')}>
        <div className={cx('recommendation-container')}>
          <h3>{localesReplacement(replacements, 'Castrol Recommendation')}</h3>
        </div>
        <div className={cx('container')}>
          <div className={cx('sider')}>
            <OilThumb
              withoutMoreLink={true}
              dataList={dataList['recommendedProduct']}
              moreLinkClick={moreLinkClick}
              maxSize={108}
              withoutLinks={true}
            />
          </div>
          <div className={cx('content')}>
            <OilRecommendationInformation
              withoutMoreLink={true}
              dataList={dataList['recommendedProduct']}
              moreLinkClick={moreLinkClick}
              productCategories={productCategories}
              withoutLinks={true}
              className='recommendation'
            />
            <OilVolumesService
              withoutMoreLink={false}
              dataList={dataList['recommendedProduct']}
              notes={notes}
              componentVolumes={dataList['vehicleComponentVolumes']}
              moreLinkClick={moreLinkClick}
            />
            {!!dataList.recommendedProduct.id && (
              <div className={style['links']}>
                <span
                  onClick={moreLinkClick}
                  className='secondary-button'
                  role='button'
                >
                  {localesReplacement(replacements, 'View product details')}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setServiceIntervals: (value: IServiceIntervals[]) =>
    dispatch(actions.setServiceIntervals(value)),
  setVehicleComponentVolumes: (value: IComponentVolumes[]) =>
    dispatch(actions.setVehicleComponentVolumes(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CastrolRecommendation);
